import type { EvHint, EvSize } from './types';

const PATH = '/api/controls/ev';

// Cookie-based auth: alle requests sturen de zbs_session cookie automatisch
// mee via `credentials: 'include'`. De backend accepteert ook X-API-Key
// header (voor curl/scripts) — frontend gebruikt uitsluitend cookies.

export async function fetchEvHint(): Promise<EvHint | null> {
  const res = await fetch(PATH, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch { /* ignore */ }
    throw new Error(`GET ${PATH}: ${res.status} ${body.slice(0, 200)}`);
  }
  const data = await res.json() as { hint: EvHint | null };
  return data.hint;
}

export interface SetEvHintOpts {
  nEvs?: number;
  size?: EvSize;
}

export async function setEvHint(
  emptyPct: number,
  expectedHomeHour: number,
  opts: SetEvHintOpts = {},
): Promise<EvHint> {
  const body: Record<string, unknown> = {
    empty_pct: emptyPct,
    expected_home_hour: expectedHomeHour,
  };
  if (opts.nEvs !== undefined) body.n_evs = opts.nEvs;
  if (opts.size !== undefined) body.size = opts.size;

  const res = await fetch(PATH, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let bodyTxt = '';
    try { bodyTxt = await res.text(); } catch { /* ignore */ }
    throw new Error(`POST ${PATH}: ${res.status} ${bodyTxt.slice(0, 200)}`);
  }
  const data = await res.json() as { hint: EvHint };
  return data.hint;
}

export async function cancelEvHint(): Promise<void> {
  const res = await fetch(PATH, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ cancel: true }),
  });
  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch { /* ignore */ }
    throw new Error(`POST ${PATH}: ${res.status} ${body.slice(0, 200)}`);
  }
}
